import { render, staticRenderFns } from "./WallkitPlanView.vue?vue&type=template&id=b4f66b84"
import script from "./WallkitPlanView.vue?vue&type=script&lang=js"
export * from "./WallkitPlanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports